export type SliderRangeInput = readonly (number | undefined)[] | undefined;

export interface NormalizedSliderRange {
  readonly domain: [number, number];
  readonly values: [number, number];
}

const FALLBACK_DOMAIN = [0, 100] as const;

const isValidRange = (
  range: SliderRangeInput
): range is readonly [number, number] => {
  if (!range || range.length !== 2) return false;

  const [min, max] = range;
  return (
    typeof min === 'number' &&
    Number.isFinite(min) &&
    typeof max === 'number' &&
    Number.isFinite(max) &&
    min < max
  );
};

export const normalizeSliderRange = (
  domain?: SliderRangeInput,
  values?: SliderRangeInput
): NormalizedSliderRange => {
  const resolvedDomain: [number, number] = isValidRange(domain)
    ? [domain[0], domain[1]]
    : [...FALLBACK_DOMAIN];

  const resolvedValues: [number, number] = isValidRange(values)
    ? [values[0], values[1]]
    : [resolvedDomain[0], resolvedDomain[1]];

  const valuesAreInDomain =
    resolvedValues[0] >= resolvedDomain[0] &&
    resolvedValues[1] <= resolvedDomain[1];

  return {
    domain: resolvedDomain,
    values: valuesAreInDomain ? resolvedValues : [...resolvedDomain],
  };
};
